import { useMutation } from '@tanstack/react-query'

import * as snugNotifier from 'app/services/snugNotifier'
import { submitTenancyTransfer } from 'services/tenancyTransferApi'

type TenancyTransferData = {
  unitNumber?: string
  streetNumber: string
  streetName: string
  suburb: string
  state: string
  postcode: string
  leaseStartDate: string
  weeklyRent: number
  email?: string
  mobile?: string
  firstName?: string
  lastName?: string
  message?: string
}

type MutationOptions = {
  onSuccess?: (data: unknown) => void
  [key: string]: unknown
}

/**
 * Hook to submit tenancy transfer
 */
export const useTenancyTransferMutation = (
  teamGUID: string,
  options: MutationOptions = {},
) => {
  return useMutation({
    mutationFn: (transferData: TenancyTransferData) => {
      if (!teamGUID) {
        throw new Error('Team GUID is required')
      }
      return submitTenancyTransfer(teamGUID, transferData)
    },
    onSuccess: (data) => {
      options.onSuccess?.(data)
    },
    onError: (error: Error) => {
      const errorMessage =
        error?.message || 'Failed to submit tenancy transfer request'
      snugNotifier.error(errorMessage)
    },
    ...options,
  })
}
